import Tween from './Tween.js';

function hexToRGB(hex) {
    hex = hex.replace(/^#/, '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r , g , b ];
}

// Inside the block editor's canvas iframe this module can evaluate before <body> exists.
const bodyStyle = getComputedStyle(document.body || document.documentElement)
let colors = {
    'color-primary' :    bodyStyle.getPropertyValue('--color-primary').split(' '),
    'color-secondary' :  bodyStyle.getPropertyValue('--color-secondary').split(' '),

    'logo-color-0': '#F25022',
    'logo-color-1': '#80BA01',
    'logo-color-2': '#02A4EF',
    'logo-color-3': '#FFB902',
    'logo-color-4': '#FFB902',

    'default-logo-color-0': '#F25022',
    'default-logo-color-1': '#80BA01',
    'default-logo-color-2': '#02A4EF',
    'default-logo-color-3': '#FFB902',
    'default-logo-color-4': '#737373',

}

const $themeSwitchers = [];

let observer  = new IntersectionObserver( onIntersect, { rootMargin: `0px 0px ${window.innerHeight*-0.5}px 0px`});

function onIntersect(entries) {
    entries.forEach((el)=>{
        const colorPrimary   = el.target.getAttribute('data-color-primary') ;
        const colorSecondary = el.target.getAttribute('data-color-secondary') ;
        if (el.isIntersecting && colorPrimary && colorSecondary) {
            ThemeManager.tween('color-primary',    colorPrimary,      () => {});
            ThemeManager.tween('color-secondary',  colorSecondary,    () => {});
        }
        else {
        }
    });
}

function onResize()  {
    $themeSwitchers.forEach(el => observer.unobserve(el) );
    observer = new IntersectionObserver( onIntersect, { rootMargin: `0px 0px ${window.innerHeight*-0.5}px 0px`});
    $themeSwitchers.forEach(el => observer.observe(el) );
}
window.addEventListener('resize',  onResize);


const ThemeManager = {
    callbacks: {},
    registerBackgroundSwitcher: (el)=>{
        $themeSwitchers.push( el );
        observer.observe( el );
    },
    on(eventName, callback) {
        this.callbacks[eventName] = this.callbacks[eventName] || [];
        this.callbacks[eventName].push(callback)
    },
    tween(cssVar, destColor, onStep) {
        
        const startColor = colors[cssVar] ;

        const startLogoColors = [
            colors['logo-color-0'],
            colors['logo-color-1'],
            colors['logo-color-2'],
            colors['logo-color-3'],
            colors['logo-color-4'],
        ]

        Tween({e:0}, {
            to: {e:1},
            easing: [0.43, 0.195, 0.02, 1],
            step: e => {
                let colorA = startColor;
                let colorB = /\#/.test(destColor) ? hexToRGB(destColor) : destColor;
                let c = [
                    Number(colorA[0]) + (Number(colorB[0]) - Number(colorA[0])) * e,
                    Number(colorA[1]) + (Number(colorB[1]) - Number(colorA[1])) * e,
                    Number(colorA[2]) + (Number(colorB[2]) - Number(colorA[2])) * e
                ];
                colors[cssVar] = c;
                document.body.style.setProperty('--'+cssVar, `${c[0]} ${c[1]} ${c[2]}`);
                if (this.callbacks['color:change']) {
                    this.callbacks['color:change']?.forEach( cb => cb( cssVar, c ) );
                }

                if (cssVar === 'color-secondary') {
                    for (let i=0; i<5; i++) {
                        const destLogoColor =  destColor === '#F4F4F4' ? colors['default-logo-color-'+i] : colors['color-primary'] ;
                        let colorA = /\#/.test(startLogoColors[i]) ? hexToRGB(startLogoColors[i]) : startLogoColors[i];  ;
                        let colorB = /\#/.test(destLogoColor) ? hexToRGB(destLogoColor) : destLogoColor;
                        let c = [
                            Number(colorA[0]) + (Number(colorB[0]) - Number(colorA[0])) * e,
                            Number(colorA[1]) + (Number(colorB[1]) - Number(colorA[1])) * e,
                            Number(colorA[2]) + (Number(colorB[2]) - Number(colorA[2])) * e
                        ];
                        colors['logo-color-'+i] = c;
                        document.body.style.setProperty('--'+'logo-color-'+i, `${c[0]} ${c[1]} ${c[2]}`);
                    }
                }

            }
        });
    }
}

export default ThemeManager;
